// Standalone so `routeURLs` and the router can use these tabs without importing the page itself,
// which would pull the page and its dependencies into the initial bundle.
export enum TRIP_DETAILS_TAB_LIST {
  DETAILS = 'details',
  PASSENGERS = 'passengers',
  FINANCES = 'finances',
  TASKS = 'tasks',
  NOTES = 'notes',
  TRIP_REPORTS = 'trip-reports',
  ACTIVITY_HISTORY = 'activity-history',
}
